import { SilverbackPageContext } from '@amazeelabs/gatsby-source-silverback';

import { useContentHubQuery } from '../../generated/queries/react-queries';
import { languageFallback } from '../utils/localizations';
import { usePager } from './pager';
import { useQueryParamString } from './query-string';

export const useContentHubFilter = (
  pageContext: SilverbackPageContext,
  itemsPerPage?: string,
  initialValues?: {
    types?: string[];
    topics?: string[];
    countries?: string[];
  },
) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [filters, setFilters] = useQueryParamString('filters', '');
  let currentValues;
  try {
    currentValues = JSON.parse(filters);
  } catch (e) {
    currentValues = {};
  }
  // We have some predefined filters
  if (
    (initialValues?.types ||
      initialValues?.topics ||
      initialValues?.countries) &&
    !filters
  ) {
    setFilters(JSON.stringify(initialValues));
  }
  const [currentPage, setCurrentPage] = useQueryParamString('page', '0');

  const contentHubResults = useContentHubQuery({
    input: {
      langcode: languageFallback(pageContext.locale || 'de'),
      filters: {
        topics: currentValues.themes || [],
        types: currentValues.types || [],
        countries: currentValues.countries || [],
      },
      pagination: {
        offset: parseInt(currentPage || '0') * parseInt(itemsPerPage || '18'),
        limit: parseInt(itemsPerPage || '18'),
      },
      skipResults: false,
    },
  });
  const {
    firstPage,
    lastPage,
    nextPage,
    previousPage,
    pages,
    hasMissingLeftPages,
    hasMissingRightPages,
  } = usePager({
    name: 'page',
    totalItems: contentHubResults.data?.contentHub.total || 0,
    itemsPerPage: parseInt(itemsPerPage || '20'),
    pagesToShow: 5,
    setCurrentPage,
    currentPage,
    onPageChange: () => {
      if (window !== undefined) {
        const filters = document.getElementById('listing-filters');
        if (filters) {
          filters.scrollIntoView();
        } else {
          // Otherwise let's scroll to the first page container
          const firstPageContainer =
            document.getElementsByClassName('container-page');
          if (firstPageContainer[0]) {
            firstPageContainer[0].scrollIntoView();
          }
        }
      }
    },
  });

  return {
    setFilters,
    currentValues,
    contentHubResults,
    pager:
      (pages.length > 1 && {
        firstPage,
        previousPage,
        nextPage,
        lastPage,
        pages,
        hasMissingLeftPages,
        hasMissingRightPages,
        setCurrentPage,
      }) ||
      undefined,
    resultsAreLoading: contentHubResults.isLoading,
  };
};
